// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"CreateDutyRosterModal_imageWrapper__3O8HR","image":"CreateDutyRosterModal_image__2PvbO"};